export function TurnSignalHud({ direction }) {
	const left_arrow = direction === 'LEFT' || direction === 'BOTH';
	const right_arrow = direction === 'RIGHT' || direction === 'BOTH';

	return (
		<div className='absolute left-1/2 top-10 flex -translate-x-1/2 transform bg-[initial]'>
			<div className='flex -translate-x-[92px] transform flex-row'>
				<div style={{ lineHeight: 0, textAlign: 'center' }}>
					<div className='absolute'>
						<svg
							width='44'
							height='72'
							xmlns='http://www.w3.org/2000/svg'
							xmlnsXlink='http://www.w3.org/1999/xlink'
							overflow='hidden'
							type='image/svg+xml'
						>
							<title>hud turn left signal</title>
							<defs>
								<filter id='f1' x='0' y='0'>
									<feGaussianBlur in='SourceGraphic' stdDeviation='0.2' />
								</filter>
							</defs>
							<g transform='scale(4)'>
								<path
									fill='none'
									stroke='rgba(255,255,255,0.5)'
									strokeWidth='0.1'
									d='M10.36,17.32l-9.9-8.24l9.9-8.24C9.06,6.21,8.94,11.7,10.36,17.32L10.36,17.32z'
								/>
								<path
									filter='url(#f1)'
									fill={left_arrow ? 'cyan' : 'none'}
									stroke='cyan white'
									style={{ animation: 'blink 1s linear infinite' }}
									d='M10.36,17.32l-9.9-8.24l9.9-8.24C9.06,6.21,8.94,11.7,10.36,17.32L10.36,17.32z'
								></path>
							</g>
						</svg>
					</div>
					<div className='relative left-[190px]'>
						<svg
							width='44'
							height='72'
							xmlns='http://www.w3.org/2000/svg'
							xmlnsXlink='http://www.w3.org/1999/xlink'
							overflow='hidden'
							type='image/svg+xml'
						>
							<title>hud turn right signal</title>
							<g transform='scale(4)'>
								<path
									fill='none'
									stroke='rgba(255,255,255,0.5)'
									strokeWidth='0.1'
									d='M0.46,17.32l9.9-8.24l-9.9-8.24C1.76,6.21,1.87,11.7,0.46,17.32L0.46,17.32z'
								/>
								<path
									filter='url(#f1)'
									fill={right_arrow ? 'cyan' : 'none'}
									stroke='cyan white'
									style={{ animation: 'blink 1s linear infinite' }}
									d='M0.46,17.32l9.9-8.24l-9.9-8.24C1.76,6.21,1.87,11.7,0.46,17.32L0.46,17.32z'
								></path>
							</g>
						</svg>
					</div>
				</div>
			</div>
		</div>
	);
}
